module.exports = __webpack_public_path__ + "static/rentacar-ce8ea800ba117d7d5dbdf474710fc24b.jpg";